import axios from 'axios'
import axiosCustom from './axiosCustom'

export default class AuthService {
    constructor(auth_url) {
        this.auth_url = auth_url
        this.login = this.login.bind(this)
        this.refreshtoken = this.refreshtoken.bind(this)
        this.isLoggedIn = this.isLoggedIn.bind(this)
        this.logout = this.logout.bind(this)
        this.getAccessToken = this.getAccessToken.bind(this)
        this.setAccessToken = this.setAccessToken.bind(this)
        this.clearAccessToken = this.clearAccessToken.bind(this)
        this.handleResponse = this.handleResponse.bind(this)
    }

    login(username, password) {
        const source = axios.CancelToken.source()

        return axiosCustom
            .post(
                '/auth/login',
                {username, password},
                {
                    cancelToken: source.token,
                    timeout: process.env.REACT_APP_LOGIN_TIMEOUT,
                    validateStatus: function(status) {
                        return status < 500 // Resolve only if the status code is less than 500
                    },
                }
            )
            .then(response => this.handleResponse(response))
    }

    refreshtoken(token) {
        const source = axios.CancelToken.source()

        return axiosCustom
            .post(
                '/auth/refresh',
                {token},
                {
                    cancelToken: source.token,
                    timeout: process.env.REACT_APP_LOGIN_TIMEOUT,
                }
            )
            .then(response => this.handleResponse(response))
    }

    isLoggedIn = async () => {
        var sessionToken = sessionStorage.getItem('token')

        if (sessionToken) {
            return true
        } else {
            this.clearAccessToken()
            return false
        }
    }

    logout() {
        this.clearAccessToken()
    }

    getAccessToken() {
        return sessionStorage.getItem('token')
    }

    setAccessToken(token) {
        sessionStorage.setItem('token', token)
    }

    clearAccessToken() {
        sessionStorage.removeItem('token')
    }

    handleResponse(response) {
        if (response.status !== 200) {
            let error

            if (response.status === 401) {
                // auto logout if 401 response returned from api
                this.logout()
                error = {
                    title: 'Login error',
                    message: 'Your EUID and password do not match.',
                }
                return Promise.reject(error)
            }

            error = {title: 'Server error', message: 'Please try again later.'}
            return Promise.reject(error)
        }

        return response.data
    }
}
